import classnames from 'classnames';
import styles from './Title.module.scss';

export default function Title({ children, priority = '1', tag, noMargin, lineHeightReset, capitalize, className }) {
  const TitleTag = tag ? tag : `h${priority}`;

  return (
    <TitleTag 
      className={classnames(styles.title, className, {
        [styles.hero]: priority === 'hero',
        [styles.primary]: priority === '1',
        [styles.secondary]: priority === '2',
        [styles.tertiary]: priority === '3',
        [styles.quaternary]: priority === '4',
        [styles.noMargin]: noMargin,
        [styles.lineHeightReset]: lineHeightReset,
        [styles.capitalize]: capitalize,
      })}
    >
      {children}
    </TitleTag>
  );
}
